import { render, staticRenderFns } from "./Maskdomo.vue?vue&type=template&id=235d1bb3&scoped=true"
import script from "./Maskdomo.vue?vue&type=script&lang=js"
export * from "./Maskdomo.vue?vue&type=script&lang=js"
import style0 from "./Maskdomo.vue?vue&type=style&index=0&id=235d1bb3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235d1bb3",
  null
  
)

export default component.exports